// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"c739d4ef","853":"b3df54ea","894":"2fdcab33"}[chunkId] + ".chunk.js";
};